import { useTranslation } from 'react-i18next';

import { cn } from '~/lib/cn';

import { MusicIqIcon } from './MusicIqIcon';

interface MusicIqTitleProps {
  iconClassName?: string;
  titleClassName?: string;
  onClick?: () => void;
}

export function MusicIqTitle({
  iconClassName,
  titleClassName,
  onClick,
}: MusicIqTitleProps) {
  const { t } = useTranslation('data');

  return (
    <button
      type="button"
      className="flex items-center gap-sm"
      onClick={onClick}
      disabled={!onClick}
      aria-disabled={!onClick}
    >
      <MusicIqIcon className={cn('size-[44px]', iconClassName)} />
      <div
        className={cn(
          'text-display-md font-bold text-tertiary-default',
          titleClassName,
        )}
      >
        {t('musicIq.pageTitle')}
      </div>
    </button>
  );
}

MusicIqTitle.displayName = 'MusicIqTitle';
